var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgWallet = function SvgWallet(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 36,
    viewBox: "0 0 43 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_69)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 6.15843V21.8414C4.5 25.0423 7.0878 27.6373 10.28 27.6373H32.72C35.9121 27.6373 38.5 25.0423 38.5 21.8414V6.15843C38.5 2.95745 35.9121 0.362549 32.72 0.362549H10.28C7.0878 0.362549 4.5 2.95745 4.5 6.15843Z",
    fill: "#111111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 6.15843V21.8414C4.5 25.0423 7.0878 27.6373 10.28 27.6373H32.72C35.9121 27.6373 38.5 25.0423 38.5 21.8414V6.15843C38.5 2.95745 35.9121 0.362549 32.72 0.362549H10.28C7.0878 0.362549 4.5 2.95745 4.5 6.15843Z",
    fill: "url(#paint0_linear_1_69)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0001 7.18124C13.0001 6.23977 12.239 5.47656 11.3001 5.47656C10.3612 5.47656 9.6001 6.23977 9.6001 7.18124C9.6001 8.1227 10.3612 8.88591 11.3001 8.88591C12.239 8.88591 13.0001 8.1227 13.0001 7.18124Z",
    fill: "url(#paint1_linear_1_69)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0001 7.18124C13.0001 6.23977 12.239 5.47656 11.3001 5.47656C10.3612 5.47656 9.6001 6.23977 9.6001 7.18124C9.6001 8.1227 10.3612 8.88591 11.3001 8.88591C12.239 8.88591 13.0001 8.1227 13.0001 7.18124Z",
    fill: "url(#paint2_linear_1_69)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0001 7.18124C13.0001 6.23977 12.239 5.47656 11.3001 5.47656C10.3612 5.47656 9.6001 6.23977 9.6001 7.18124C9.6001 8.1227 10.3612 8.88591 11.3001 8.88591C12.239 8.88591 13.0001 8.1227 13.0001 7.18124Z",
    fill: "url(#paint3_linear_1_69)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0001 20.8075C13.0001 19.866 12.239 19.1028 11.3001 19.1028C10.3612 19.1028 9.6001 19.866 9.6001 20.8075C9.6001 21.749 10.3612 22.5122 11.3001 22.5122C12.239 22.5122 13.0001 21.749 13.0001 20.8075Z",
    fill: "url(#paint4_linear_1_69)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4001 13.9997C33.4001 13.0582 32.6389 12.2949 31.7001 12.2949C30.7611 12.2949 30 13.0582 30 13.9997C30 14.9411 30.7611 15.7043 31.7001 15.7043C32.6389 15.7043 33.4001 14.9411 33.4001 13.9997Z",
    fill: "url(#paint5_linear_1_69)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.4001 13.9997C33.4001 13.0582 32.6389 12.2949 31.7001 12.2949C30.7611 12.2949 30 13.0582 30 13.9997C30 14.9411 30.7611 15.7043 31.7001 15.7043C32.6389 15.7043 33.4001 14.9411 33.4001 13.9997Z",
    fill: "url(#paint6_linear_1_69)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7 5.47656H18.1C17.161 5.47656 16.3999 6.23977 16.3999 7.18124C16.3999 8.1227 17.161 8.88591 18.1 8.88591H31.7C32.6388 8.88591 33.4 8.1227 33.4 7.18124C33.4 6.23977 32.6388 5.47656 31.7 5.47656Z",
    fill: "url(#paint7_linear_1_69)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7 19.1028H18.1C17.161 19.1028 16.3999 19.866 16.3999 20.8075C16.3999 21.749 17.161 22.5122 18.1 22.5122H31.7C32.6388 22.5122 33.4 21.749 33.4 20.8075C33.4 19.866 32.6388 19.1028 31.7 19.1028Z",
    fill: "url(#paint8_linear_1_69)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9 12.2949H11.3001C10.3612 12.2949 9.6001 13.0582 9.6001 13.9997C9.6001 14.9411 10.3612 15.7043 11.3001 15.7043H24.9C25.839 15.7043 26.6001 14.9411 26.6001 13.9997C26.6001 13.0582 25.839 12.2949 24.9 12.2949Z",
    fill: "url(#paint9_linear_1_69)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_69",
    x: 0.5,
    y: 0.362549,
    width: 42,
    height: 35.2747,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_69"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_69",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_69",
    x1: 21.4999,
    y1: 0.362552,
    x2: 21.4999,
    y2: 27.6656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D273D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D0F13"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_69",
    x1: 10.1238,
    y1: 8.86256,
    x2: 12.442,
    y2: 5.77165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4462FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D69FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_69",
    x1: 9.89888,
    y1: 8.88756,
    x2: 12.7544,
    y2: 8.74159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3757FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6980FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_69",
    x1: 9.89888,
    y1: 8.88756,
    x2: 12.7544,
    y2: 8.74159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2447FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6980FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_69",
    x1: 10.0809,
    y1: 21.9557,
    x2: 12.3562,
    y2: 19.5517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC3EE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D972F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_69",
    x1: 30.6869,
    y1: 15.13,
    x2: 32.7904,
    y2: 12.8977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#29BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96E7FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1_69",
    x1: 30.2731,
    y1: 15.681,
    x2: 33.2256,
    y2: 15.5397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85E7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1_69",
    x1: 17.7651,
    y1: 8.86256,
    x2: 31.7601,
    y2: 5.51407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23BBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85E7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1_69",
    x1: 17.8939,
    y1: 22.5139,
    x2: 31.3307,
    y2: 19.0794,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2447FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6980FA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1_69",
    x1: 11.8839,
    y1: 15.7309,
    x2: 24.7198,
    y2: 12.2966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6634FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C6DFF"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgWallet);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/wallet.4e29e0aafe3a14da75a48167debaaaef.svg";